import { render, staticRenderFns } from "./TableProjectContacts.vue?vue&type=template&id=3d1221d0&"
import script from "./TableProjectContacts.vue?vue&type=script&lang=js&"
export * from "./TableProjectContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports